import React from "react";
import "react-step-progress-bar/styles.css";
import { ProgressBar } from "react-step-progress-bar";
import { Step } from "./components/step";
import { useOrderProgressState } from "./hooks/use-order-progress-state";
import "./styles.css";
import Delivered_Complete from "../../assets/order-progress/delivered_accomplished.svg";
import Delivered from "../../assets/order-progress/delivered.svg";
import Delivery_Complete from "../../assets/order-progress/delivery_accomplished.svg";
import Delivery from "../../assets/order-progress/delivery.svg";
import OrderPlaced_Complete from "../../assets/order-progress/order_placed_accomplished.svg";
import Packaging_Complete from "../../assets/order-progress/packaging_accomplished.svg";
import Packaging from "../../assets/order-progress/packaging.svg";
export function OrderProgress(props) {
    const { status } = props;
    const { percentage } = useOrderProgressState({ status });
    return (React.createElement(ProgressBar, { percent: percentage, filledBackground: "#192145" },
        React.createElement(Step, { icon: OrderPlaced_Complete }),
        React.createElement(Step, { icon: percentage > 33 ? Packaging_Complete : Packaging }),
        React.createElement(Step, { icon: percentage > 66 ? Delivery_Complete : Delivery }),
        React.createElement(Step, { icon: percentage == 100 ? Delivered_Complete : Delivered })));
}
